import { render, staticRenderFns } from "./ContractWidgetSubscription.vue?vue&type=template&id=72034d22&"
import script from "./ContractWidgetSubscription.vue?vue&type=script&lang=js&"
export * from "./ContractWidgetSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports